import _styled, { css as _css, default as _styled2 } from "styled-components";
import React from "react";
import { useNavLayout } from "~/features/app/landing-header/context";
import { debounce } from "~/features/app/utils";
import Headroom from "~/features/ui/headroom";
type Props = {
  left: React.ReactNode;
  center: React.ReactNode;
  right: React.ReactNode;
};
const headerStyles = /*#__PURE__*/_css(["", " .headroom{", "}.headroom--unfixed{", " transform:translateY(0);}.headroom--scrolled{", "}.headroom--unpinned{", " transform:translateY(-100%);}.headroom--pinned{", " transform:translateY(0%);}"], {
  "pointerEvents": "none",
  "position": "absolute",
  "left": "0",
  "right": "0",
  "zIndex": "30"
}, {
  "position": "fixed",
  "left": "0",
  "right": "0",
  "zIndex": "10",
  "willChange": "transform"
}, {
  "position": "relative"
}, {
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
}, {
  "position": "fixed"
}, {
  "position": "fixed"
});
const withAnnouncementBarStyles = /*#__PURE__*/_css([".headroom--unpinned,.headroom--pinned{", ";}"], {
  "marginTop": "calc(var(--announcement-bar-height) * -1)"
});
export function LandingHeader(props: Props) {
  const {
    right,
    center,
    left
  } = props;
  const {
    setNavTheme,
    navTheme,
    setNavLayout,
    isSubNavVisible,
    isAnnouncementBarVisible
  } = useNavLayout();
  const [pinStart, setPinStart] = React.useState(0);
  const originalTheme = React.useRef(navTheme);
  function onUnfix() {
    setNavTheme(originalTheme.current);
    setNavLayout("default");
  }
  function onPin() {
    setNavTheme("solid");
    setNavLayout("condensed");
  }
  React.useEffect(() => {
    function onResize() {
      setPinStart(window.innerHeight);
    }
    onResize();
    const debouncedOnResize = debounce(onResize);
    window.addEventListener("resize", debouncedOnResize);
    return () => {
      window.removeEventListener("resize", debouncedOnResize);
    };
  }, []);
  return <_StyledHeader $_css2={[headerStyles, isAnnouncementBarVisible ? [withAnnouncementBarStyles, {
    "top": "var(--announcement-bar-height)"
  }] : {
    "top": "0"
  }]}>
      <Headroom onUnfix={onUnfix} onPin={onPin} disableInlineStyles disable={isSubNavVisible} pinStart={pinStart}>
        <_StyledDiv>
          {left}
          {center}
          {right}
        </_StyledDiv>
      </Headroom>
    </_StyledHeader>;
}
var _StyledHeader = /*#__PURE__*/_styled("header").withConfig({
  componentId: "sc-sf-i6n25c-0"
})`${p => p.$_css2}`;
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "landing-header___StyledDiv",
  componentId: "sc-1sx72ng-0"
})({
  "display": "flex"
});